import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import GoTo from "../components/GoTo";
import PageTitle from "../components/PageTitle";
import { useLanguage } from "../context/LanguageContext";

function ContactPage() {
  const { language } = useLanguage();

  // Helper function to add language prefix to paths
  const getLocalizedPath = (path) => {
    // Split path and query string
    const [pathPart, queryString] = path.split("?");
    
    if (language === "ar") {
      // Remove /ar if already present to avoid duplication
      const cleanPath = pathPart.startsWith("/ar") ? pathPart.replace("/ar", "") : pathPart;
      const localizedPath = `/ar${cleanPath === "/" ? "" : cleanPath}`;
      return queryString ? `${localizedPath}?${queryString}` : localizedPath;
    }
    // Remove /ar prefix if present when switching to English
    const englishPath = pathPart.startsWith("/ar") ? pathPart.replace("/ar", "") || "/" : pathPart;
    return queryString ? `${englishPath}?${queryString}` : englishPath;
  };
  return (
    <>
      <style>
        {`
          /* Bluish color for page title - matching ShopCollection */
          .tf-page-title.style-2-edit .heading {
            color: #0e5aa7 !important;
          }
        `}
      </style>
      <Header />
      <PageTitle title={language === "ar" ? "اتصل بنا" : "Contact Us"} />

      <div
        className="tf-contact tf-section"
        style={{
          background: "linear-gradient(45deg, #f8f9fa 0%, #e9ecef 100%)",
          padding: "80px 0",
        }}
      >
        <div className="tf-container">
          <div className="row">
            <div className="col-12">
              <div className="tf-contact-heading text-center mb-5">
                <h2
                  className="tf-title-heading tf-title-heading-style-2 mb-3"
                  style={{
                    fontSize: "2.5rem",
                    fontWeight: "600",
                    color: "#2c3e50",
                  }}
                >
                  {language === "ar" ? "تواصل معنا" : "Get In Touch"}
                </h2>
                <p
                  className="tf-sub-heading"
                  style={{
                    fontSize: "1.2rem",
                    color: "#6c757d",
                    maxWidth: "600px",
                    margin: "0 auto",
                  }}
                >
                  {language === "ar"
                    ? "تواصل معنا من خلال قنوات التواصل الاجتماعي وابق على اطلاع بآخر أخبارنا"
                    : "Connect with us through our social media channels and stay updated with our latest news"}
                </p>
              </div>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-10 col-md-12">
              <div className="tf-contact-social">
                <div className="row">
                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div
                      className="tf-contact-social-item text-center"
                      style={{
                        background: "white",
                        borderRadius: "20px",
                        padding: "40px 20px",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                        transition: "all 0.3s ease",
                        border: "1px solid rgba(0,0,0,0.05)",
                        height: "100%",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-10px)";
                        e.currentTarget.style.boxShadow =
                          "0 20px 40px rgba(0,0,0,0.15)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 10px 30px rgba(0,0,0,0.1)";
                      }}
                    >
                      <div className="tf-contact-social-icon mb-3">
                        <a
                          href="https://www.facebook.com/elsallab/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="box-icon w_60 round social-facebook"
                          style={{
                            background:
                              "linear-gradient(45deg, #0e5aa7, #0c4e94)",
                            border: "none",
                            boxShadow: "0 6px 15px rgba(14, 90, 167, 0.3)",
                            width: "60px",
                            height: "60px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <i
                            className="icon fs-18 icon-fb"
                            style={{ color: "white" }}
                          ></i>
                        </a>
                      </div>
                      <h4
                        style={{
                          color: "#2c3e50",
                          fontWeight: "600",
                          marginBottom: "15px",
                        }}
                      >
                        Facebook
                      </h4>
                      <p style={{ color: "#6c757d", marginBottom: "25px" }}>
                        {language === "ar"
                          ? "تابعنا على فيسبوك للحصول على التحديثات والأخبار"
                          : "Follow us on Facebook for updates and news"}
                      </p>
                      <a
                        href="https://www.facebook.com/elsallab/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="tf-btn btn-line"
                        style={{
                          background:
                            "linear-gradient(45deg, #0e5aa7, #0c4e94)",
                          color: "white",
                          border: "none",
                          borderRadius: "25px",
                          padding: "12px 30px",
                          fontWeight: "500",
                          textDecoration: "none",
                          display: "inline-block",
                          transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "scale(1.05)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                      >
                        {language === "ar" ? "زيارة الصفحة" : "Visit Page"}
                      </a>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div
                      className="tf-contact-social-item text-center"
                      style={{
                        background: "white",
                        borderRadius: "20px",
                        padding: "40px 20px",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                        transition: "all 0.3s ease",
                        border: "1px solid rgba(0,0,0,0.05)",
                        height: "100%",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-10px)";
                        e.currentTarget.style.boxShadow =
                          "0 20px 40px rgba(0,0,0,0.15)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 10px 30px rgba(0,0,0,0.1)";
                      }}
                    >
                      <div className="tf-contact-social-icon mb-3">
                        <a
                          href="https://x.com/abdelazizsallab"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="box-icon w_60 round social-twiter"
                          style={{
                            background:
                              "linear-gradient(45deg, #0e5aa7, #0c4e94)",
                            border: "none",
                            boxShadow: "0 6px 15px rgba(14, 90, 167, 0.3)",
                            width: "60px",
                            height: "60px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <i
                            className="icon fs-16 icon-Icon-x"
                            style={{ color: "white" }}
                          ></i>
                        </a>
                      </div>
                      <h4
                        style={{
                          color: "#2c3e50",
                          fontWeight: "600",
                          marginBottom: "15px",
                        }}
                      >
                        Twitter
                      </h4>
                      <p style={{ color: "#6c757d", marginBottom: "25px" }}>
                        {language === "ar"
                          ? "ابق على اطلاع بآخر تغريداتنا"
                          : "Stay updated with our latest tweets"}
                      </p>
                      <a
                        href="https://x.com/abdelazizsallab"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="tf-btn btn-line"
                        style={{
                          background:
                            "linear-gradient(45deg, #0e5aa7, #0c4e94)",
                          color: "white",
                          border: "none",
                          borderRadius: "25px",
                          padding: "12px 30px",
                          fontWeight: "500",
                          textDecoration: "none",
                          display: "inline-block",
                          transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "scale(1.05)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                      >
                        {language === "ar" ? "تابعنا" : "Follow Us"}
                      </a>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div
                      className="tf-contact-social-item text-center"
                      style={{
                        background: "white",
                        borderRadius: "20px",
                        padding: "40px 20px",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                        transition: "all 0.3s ease",
                        border: "1px solid rgba(0,0,0,0.05)",
                        height: "100%",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-10px)";
                        e.currentTarget.style.boxShadow =
                          "0 20px 40px rgba(0,0,0,0.15)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 10px 30px rgba(0,0,0,0.1)";
                      }}
                    >
                      <div className="tf-contact-social-icon mb-3">
                        <a
                          href="https://www.instagram.com/abdelaziz.elsallab/"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="box-icon w_60 round social-instagram"
                          style={{
                            background:
                              "linear-gradient(45deg, #0e5aa7, #0c4e94)",
                            border: "none",
                            boxShadow: "0 6px 15px rgba(14, 90, 167, 0.3)",
                            width: "60px",
                            height: "60px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <i
                            className="icon fs-18 icon-instagram"
                            style={{ color: "white" }}
                          ></i>
                        </a>
                      </div>
                      <h4
                        style={{
                          color: "#2c3e50",
                          fontWeight: "600",
                          marginBottom: "15px",
                        }}
                      >
                        Instagram
                      </h4>
                      <p style={{ color: "#6c757d", marginBottom: "25px" }}>
                        {language === "ar"
                          ? "شاهد أحدث منتجاتنا وخلف الكواليس"
                          : "See our latest products and behind-the-scenes"}
                      </p>
                      <a
                        href="https://www.instagram.com/abdelaziz.elsallab/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="tf-btn btn-line"
                        style={{
                          background:
                            "linear-gradient(45deg, #0e5aa7, #0c4e94)",
                          color: "white",
                          border: "none",
                          borderRadius: "25px",
                          padding: "12px 30px",
                          fontWeight: "500",
                          textDecoration: "none",
                          display: "inline-block",
                          transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "scale(1.05)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                      >
                        {language === "ar" ? "تابعنا" : "Follow Us"}
                      </a>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div
                      className="tf-contact-social-item text-center"
                      style={{
                        background: "white",
                        borderRadius: "20px",
                        padding: "40px 20px",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                        transition: "all 0.3s ease",
                        border: "1px solid rgba(0,0,0,0.05)",
                        height: "100%",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-10px)";
                        e.currentTarget.style.boxShadow =
                          "0 20px 40px rgba(0,0,0,0.15)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 10px 30px rgba(0,0,0,0.1)";
                      }}
                    >
                      <div className="tf-contact-social-icon mb-3">
                        <a
                          href="https://www.tiktok.com/@abdelazzizelsallab"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="box-icon w_60 round social-tiktok"
                          style={{
                            background:
                              "linear-gradient(45deg, #0e5aa7, #0c4e94)",
                            border: "none",
                            boxShadow: "0 6px 15px rgba(14, 90, 167, 0.3)",
                            width: "60px",
                            height: "60px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <i
                            className="icon fs-18 icon-tiktok"
                            style={{ color: "white" }}
                          ></i>
                        </a>
                      </div>
                      <h4
                        style={{
                          color: "#2c3e50",
                          fontWeight: "600",
                          marginBottom: "15px",
                        }}
                      >
                        TikTok
                      </h4>
                      <p style={{ color: "#6c757d", marginBottom: "25px" }}>
                        {language === "ar"
                          ? "شاهد محتوانا الممتع والإبداعي"
                          : "Watch our fun and creative content"}
                      </p>
                      <a
                        href="https://www.tiktok.com/@abdelazzizelsallab"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="tf-btn btn-line"
                        style={{
                          background:
                            "linear-gradient(45deg, #0e5aa7, #0c4e94)",
                          color: "white",
                          border: "none",
                          borderRadius: "25px",
                          padding: "12px 30px",
                          fontWeight: "500",
                          textDecoration: "none",
                          display: "inline-block",
                          transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "scale(1.05)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                      >
                        {language === "ar" ? "تابعنا" : "Follow Us"}
                      </a>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div
                      className="tf-contact-social-item text-center"
                      style={{
                        background: "white",
                        borderRadius: "20px",
                        padding: "40px 20px",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                        transition: "all 0.3s ease",
                        border: "1px solid rgba(0,0,0,0.05)",
                        height: "100%",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-10px)";
                        e.currentTarget.style.boxShadow =
                          "0 20px 40px rgba(0,0,0,0.15)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 10px 30px rgba(0,0,0,0.1)";
                      }}
                    >
                      <div className="tf-contact-social-icon mb-3">
                        <a
                          href="https://www.youtube.com/@abdelazizelsallab5936"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="box-icon w_60 round social-youtube"
                          style={{
                            background:
                              "linear-gradient(45deg, #0e5aa7, #0c4e94)",
                            border: "none",
                            boxShadow: "0 6px 15px rgba(14, 90, 167, 0.3)",
                            width: "60px",
                            height: "60px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <i
                            className="icon fs-18 icon-youtube"
                            style={{ color: "white" }}
                          ></i>
                        </a>
                      </div>
                      <h4
                        style={{
                          color: "#2c3e50",
                          fontWeight: "600",
                          marginBottom: "15px",
                        }}
                      >
                        YouTube
                      </h4>
                      <p style={{ color: "#6c757d", marginBottom: "25px" }}>
                        {language === "ar"
                          ? "اشترك في قناتنا لمشاهدة الفيديوهات والدروس التعليمية"
                          : "Subscribe to our channel for videos and tutorials"}
                      </p>
                      <a
                        href="https://www.youtube.com/@abdelazizelsallab5936"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="tf-btn btn-line"
                        style={{
                          background:
                            "linear-gradient(45deg, #0e5aa7, #0c4e94)",
                          color: "white",
                          border: "none",
                          borderRadius: "25px",
                          padding: "12px 30px",
                          fontWeight: "500",
                          textDecoration: "none",
                          display: "inline-block",
                          transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "scale(1.05)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                      >
                        {language === "ar" ? "اشترك" : "Subscribe"}
                      </a>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 col-12 mb-4">
                    <div
                      className="tf-contact-social-item text-center"
                      style={{
                        background: "white",
                        borderRadius: "20px",
                        padding: "40px 20px",
                        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                        transition: "all 0.3s ease",
                        border: "1px solid rgba(0,0,0,0.05)",
                        height: "100%",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-10px)";
                        e.currentTarget.style.boxShadow =
                          "0 20px 40px rgba(0,0,0,0.15)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow =
                          "0 10px 30px rgba(0,0,0,0.1)";
                      }}
                    >
                      <div className="tf-contact-social-icon mb-3">
                        <a
                          href="https://wa.me/201020928193"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="box-icon w_60 round social-whatsapp"
                          style={{
                            background:
                              "linear-gradient(45deg, #0e5aa7, #0c4e94)",
                            border: "none",
                            boxShadow: "0 6px 15px rgba(14, 90, 167, 0.3)",
                            width: "60px",
                            height: "60px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <i
                            className="icon fs-18 icon-whatsapp"
                            style={{ color: "white" }}
                          ></i>
                        </a>
                      </div>
                      <h4
                        style={{
                          color: "#2c3e50",
                          fontWeight: "600",
                          marginBottom: "15px",
                        }}
                      >
                        WhatsApp
                      </h4>
                      <p style={{ color: "#6c757d", marginBottom: "25px" }}>
                        {language === "ar"
                          ? "تحدث معنا مباشرة للحصول على دعم سريع"
                          : "Chat with us directly for quick support"}
                      </p>
                      <a
                        href="https://wa.me/201020928193"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="tf-btn btn-line"
                        style={{
                          background:
                            "linear-gradient(45deg, #0e5aa7, #0c4e94)",
                          color: "white",
                          border: "none",
                          borderRadius: "25px",
                          padding: "12px 30px",
                          fontWeight: "500",
                          textDecoration: "none",
                          display: "inline-block",
                          transition: "all 0.3s ease",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "scale(1.05)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                      >
                        {language === "ar" ? "ابدأ المحادثة" : "Start Chat"}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row justify-content-center mt-5">
            <div className="col-lg-8 col-md-10">
              <div
                className="tf-contact-info text-center"
                style={{
                  background: "white",
                  borderRadius: "25px",
                  padding: "60px 40px",
                  boxShadow: "0 20px 60px rgba(0,0,0,0.1)",
                  border: "1px solid rgba(0,0,0,0.05)",
                }}
              >
                <h3
                  style={{
                    color: "#2c3e50",
                    fontWeight: "600",
                    marginBottom: "20px",
                    fontSize: "2rem",
                  }}
                >
                  {language === "ar" ? "هل تحتاج إلى مزيد من المعلومات؟" : "Need More Information?"}
                </h3>
                <p
                  style={{
                    color: "#6c757d",
                    fontSize: "1.1rem",
                    lineHeight: "1.6",
                    marginBottom: "40px",
                  }}
                >
                  {language === "ar"
                    ? "لا تتردد في التواصل معنا من خلال أي من قنوات التواصل الاجتماعي المذكورة أعلاه. نحن هنا لمساعدتك في أي أسئلة أو استفسارات قد تكون لديك."
                    : "Feel free to reach out to us through any of our social media channels above. We're here to help you with any questions or inquiries you might have."}
                </p>
                <div className="tf-contact-cta d-flex gap-3 justify-content-center flex-wrap">
                  <a
                    href={getLocalizedPath("/")}
                    className="tf-btn btn-fill"
                    style={{
                      background: "linear-gradient(45deg, #0e5aa7, #0c4e94)",
                      color: "white",
                      border: "none",
                      borderRadius: "30px",
                      padding: "15px 35px",
                      fontWeight: "600",
                      textDecoration: "none",
                      display: "inline-block",
                      transition: "all 0.3s ease",
                      boxShadow: "0 8px 25px rgba(14, 90, 167, 0.3)",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-3px)";
                      e.currentTarget.style.boxShadow =
                        "0 12px 35px rgba(14, 90, 167, 0.4)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 25px rgba(14, 90, 167, 0.3)";
                    }}
                  >
                    {language === "ar" ? "العودة إلى الرئيسية" : "Back to Home"}
                  </a>
                  <a
                    href={getLocalizedPath("/shop/collection")}
                    className="tf-btn btn-line"
                    style={{
                      background: "transparent",
                      color: "#0e5aa7",
                      border: "2px solid #0e5aa7",
                      borderRadius: "30px",
                      padding: "13px 35px",
                      fontWeight: "600",
                      textDecoration: "none",
                      display: "inline-block",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = "#0e5aa7";
                      e.currentTarget.style.color = "white";
                      e.currentTarget.style.transform = "translateY(-3px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = "transparent";
                      e.currentTarget.style.color = "#0e5aa7";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    {language === "ar" ? "تصفح المنتجات" : "Browse Products"}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add CSS animations */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        
        .tf-contact-social-item {
          animation: fadeInUp 0.6s ease-out;
        }
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .tf-contact-social-item:nth-child(1) { animation-delay: 0.1s; }
        .tf-contact-social-item:nth-child(2) { animation-delay: 0.2s; }
        .tf-contact-social-item:nth-child(3) { animation-delay: 0.3s; }
        .tf-contact-social-item:nth-child(4) { animation-delay: 0.4s; }
        .tf-contact-social-item:nth-child(5) { animation-delay: 0.5s; }
        .tf-contact-social-item:nth-child(6) { animation-delay: 0.6s; }
      `}</style>

      <Footer />
      <GoTo />
    </>
  );
}

export default ContactPage;
